import { MembraneProvider } from '@membranehq/react'
import { fetcher, setAccessToken as setApiAccessToken } from '@membranehq/ui/services/api'
import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { ErrorNotification } from '../components/ErrorNotifications'
import { ENV_CONFIG } from '../config/env'
import { AuthContext } from './use-auth'

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null)
  const [authError, setAuthError] = useState(null)

  function handleToken(token: string) {
    setApiAccessToken(token)
    // FIXME: strictNullCheck temporary fix
    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    setToken(token)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlSearchParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlSearchParams.entries())

      if (params.token) {
        handleToken(params.token)
      } else {
        // FIXME: strictNullCheck temporary fix
        // @ts-expect-error TS(2345): Argument of type '"Not authenticated: token was no... Remove this comment to see the full error message
        setAuthError('Not authenticated: token was not provided in the query.')
      }
    }
  }, [])

  const { data, error: swrError } = useSWR(token ? '/self-auth-context' : null, fetcher)

  let dataError
  if (data && !data.user) {
    dataError = `Cannot get the current user. Something is wrong with the integration UI setup.`
  }

  const error = authError || swrError || dataError

  if (!data && !error) {
    return null
  }

  const { app, user } = data ?? {}

  return (
    <>
      {data && (
        <AuthContext.Provider
          value={{
            user,
            app,
            token,
          }}
        >
          <MembraneProvider
            // FIXME: strictNullCheck temporary fix
            // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
            token={token}
            apiUri={ENV_CONFIG.ENGINE_URI}
          >
            {children}
          </MembraneProvider>
        </AuthContext.Provider>
      )}

      {!data && error && (
        <div className='loaderWrapper'>
          <ErrorNotification error={error} />
        </div>
      )}
    </>
  )
}
